import api from "PFCore/api";
import { Collection, PermissionsGroup, QueryParams } from "PFTypes";

export const fetchPermissionsGroups = ({
  page = 1,
  perPage = 0
}: QueryParams): Promise<Collection<PermissionsGroup[]>> =>
  api({
    url: "admin/permissions_groups",
    params: { page, perPage }
  });
